// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__-xElt","black":"Pill_black__aXaJw","gray":"Pill_gray__aTEP3","icon-left":"Pill_icon-left__CSWDt","icon-right":"Pill_icon-right__dDlJ0"};